import * as z from 'zod'

export const authSchema = z.object({
  back_url: z.string().optional(),
  auth_url: z.string().optional(),
  type: z.enum(['implicit', 'oauth', 'dev']).optional(),
  code: z.string().optional(),
})

export const emailResendSchema = z.object({
  email: z.string().optional(),
})

export const passwordResetSchema = z.object({
  status: z.enum(['success', 'error']).optional(),
})

export const tokenVerificationSchema = z
  .object({
    uidb64: z.string(),
    token: z.string(),
  })
  .required()

export const oAuthCodeSchema = z.object({
  state: z.string().optional(),
})
export const authQuery = authSchema.extend(emailResendSchema.shape)
export const oAuthSchema = authSchema.extend(oAuthCodeSchema.shape)

export type AuthQuery = z.infer<typeof authQuery>
export type oAuthModel = z.infer<typeof oAuthSchema>
export type AuthModel = z.infer<typeof authSchema>
export type CodeVerificationModel = z.infer<typeof emailResendSchema>
export type TokenVerificationModel = z.infer<typeof tokenVerificationSchema>
export type PasswordResetModel = z.infer<typeof passwordResetSchema>
export const defaultCodeVerificationQuery: CodeVerificationModel = {
  email: '',
}

export const defaultTokenVerificationQuery: TokenVerificationModel = {
  uidb64: '',
  token: '',
}

export const defaultAuthQuery: AuthQuery = {
  back_url: undefined,
  auth_url: undefined,
  type: 'oauth',
}

export const defaultPasswordResetQuery: PasswordResetModel = {
  status: undefined,
}

export const defaultOAuthQuery: oAuthModel = {
  back_url: undefined,
  auth_url: undefined,
  code: undefined,
  state: undefined,
  type: undefined,
}
